import { Route, Routes } from 'react-router-dom';
// import { PrivateRoutes } from 'Authentication/PrivateRoutes'
import SignInSide from 'pages/SignInSide';
import LandingPage from 'pages/Landing/Landing';
import MedicalCareDetails from 'pages/MedicalCare/MedicalCareDetails';
import FinancialManagement from 'pages/FinancialManagement/FinancialManagementDetails';
import AdministrationDetails from 'pages/Administration/Administration';
import PatientAdminLogin from 'pages/PatientAdminLogin/Index';
import ReportGeneration from 'pages/Administration/ReportGeneration/Index';
import HumanResourceSignIn from 'pages/Administration/HumanResources/Index';
import AdministrationLogin from 'pages/Administration/Admin/Index';
import Finance from 'pages/FinancialManagement/Finance/Index';
import Logistics from 'pages/FinancialManagement/Logistics/Index';
import OrderStock from 'pages/FinancialManagement/OrderStock/Index';
import Archives from 'pages/Administration/Archives/Index';
import DiagnosisManagement from 'pages/MedicalCare/DiagnosisManagement/Index';
import HospitalizationStay from 'pages/MedicalCare/HospitalizationStay/Index';
import NursingCare from 'pages/MedicalCare/NursingCare/Index';
import Reviews from 'pages/MedicalCare/Reviews/Index';
import Patient from 'pages/MedicalCare/Patient/Index';
import HospitalPharmacy from 'pages/MedicalCare/HospitalPharmacy/Index';
import Hospitalizaiton from 'pages/MedicalCare/Hospitalizaiton/Index';
import Laundry from 'pages/MedicalCare/Laundry/Index';
import LoginDetails from 'pages/LoginDetails';
import ReportLogInDetails from 'pages/ReportLogInDetails';
import Parking from 'pages/Parking/Index';
import Chaplin from 'pages/Chaplin/Index';
import OpenElisLogInDetails from 'pages/OpenElisLoginDetails';
import OpenMRSDetails from 'pages/OpenMRSDetails';
import StockDetails from 'pages/StockDetails';
import LogisDetails from 'pages/Logistics';
import FinanceDetails from 'pages/Finance';
import PharmacyLogInDetails from 'pages/HospitalPharmacyDetails';
import ParkingDetails from 'pages/ParkingDetails';
import ChaplinDetails from 'pages/Chaplin/ChaplinDetails';
import ArchivesLogInDetails from 'pages/Administration/Archives/Archivesdetails';
import HospitalizationDetails from 'pages/MedicalCare/HospitalizationStay/HospitalizationDetails';
import HumanResourceDetails from 'pages/Administration/HumanResources/HumanResourceDetails';
import TokenList from 'pages/TokenList';
import AddNewVisitForm from 'pages/AddNewVisitForm';
import DocumentVerification from 'pages/DocumentVerification';
import DocumentVerificationList from 'pages/DocumentVerification/DocumentVerificationList';
import TokenDetails from 'pages/TokenDetails';

function Router() {
  // const token = localStorage.getItem('token')
  return (
    <div>
      <Routes>
        <Route path='/' element={<SignInSide />} />
        <Route path='/login' element={<SignInSide />} />
        <Route path='/home' element={<LandingPage />} />
        <Route path='/tokenlist' element={<TokenList />} />
        <Route path='/addnewvisit' element={<AddNewVisitForm />} />
        <Route path='/token/edit/:id' element={<TokenDetails />} />
        <Route path='/medicalcare' element={<MedicalCareDetails />} />
        <Route path='/patientadminlogin' element={<PatientAdminLogin />} />
        <Route path='/financialmanagement' element={<FinancialManagement />} />
        <Route path='/administration' element={<AdministrationDetails />} />
        <Route path='/reportgeneration' element={<ReportGeneration />} />
        <Route path='/humanresources' element={<HumanResourceSignIn />} />
        <Route path='/administrationlogin' element={<AdministrationLogin />} />
        <Route path='/financelogin' element={<Finance />} />
        <Route path='/logistics' element={<Logistics />} />
        <Route path='/orderstock' element={<OrderStock />} />
        <Route path='/archives' element={<Archives />} />
        <Route path='/diagnosislogin' element={<DiagnosisManagement />} />
        <Route path='/hospitalizationstaylogin' element={<HospitalizationStay />} />
        <Route path='/nursinglogin' element={<NursingCare />} />
        <Route path='/reviewlogin' element={<Reviews />} />
        <Route path='/patientlogin' element={<Patient />} />
        <Route path='/hospitalpharmacylogin' element={<HospitalPharmacy />} />
        <Route path='/hospitalizaitonlogin' element={<Hospitalizaiton />} />
        <Route path='/laundrylogin' element={<Laundry />} />
        <Route path='/chapellogin' element={<Chaplin />} />
        <Route path='/parkinglogin' element={<Parking />} />
        <Route path='/erplogindetails' element={<LoginDetails />} />
        <Route path='/reportlogindetails' element={<ReportLogInDetails />} />
        <Route path='/openelislogindetails' element={<OpenElisLogInDetails />} />
        <Route path='/openmrslogindetails' element={<OpenMRSDetails />} />
        <Route path='/stockdetails' element={<StockDetails />} />
        <Route path='/logisdetails' element={<LogisDetails />} />
        <Route path='/financedetails' element={<FinanceDetails />} />
        <Route path='/pharmacydetails' element={<PharmacyLogInDetails />} />
        <Route path='/parkingdetails' element={<ParkingDetails />} />
        <Route path='/chaplindetails' element={<ChaplinDetails />} />
        <Route path='/archivesdetails' element={<ArchivesLogInDetails />} />
        <Route path='/hospitalizationdetails' element={<HospitalizationDetails />} />
        <Route path='/humanResourceDetails' element={<HumanResourceDetails />} />
        <Route path='/patient-document-verification' element={<DocumentVerification />} />
        <Route path='/patient-document-verification-list' element={<DocumentVerificationList />} />
      </Routes>
    </div>
  );
}

export default Router;
